import { type Dispatch, type SetStateAction, useState } from "react";
import { useOnOpen } from "web_myplann/Inspiration/Hooks/useOnOpen";

export const useResetOnOpen = <T>(open: boolean, initial: T) => {
	const [value, setValue] = useState(initial);
	useOnOpen(open, () => setValue(initial));

	return [value, setValue] as [T, Dispatch<SetStateAction<T>>];
};
